module.exports = __webpack_public_path__ + "img/icon-notification-black.7c60fb5e.svg";